import React from "react"
import { render } from "react-dom"

export default function renderReactElements(component, cls) {
  const els = document.getElementsByClassName(cls) as HTMLCollectionOf<HTMLElement>

  for (var i = 0; i < els.length; i++) {
    const el = els[i]
    const props = JSON.parse(el.dataset.reactProps)
    render(React.createElement(component, props), el)
  }
}
